import { render, staticRenderFns } from "./ExtractTable.vue?vue&type=template&id=5670b521&scoped=true"
import script from "./ExtractTable.vue?vue&type=script&lang=js"
export * from "./ExtractTable.vue?vue&type=script&lang=js"
import style0 from "./ExtractTable.vue?vue&type=style&index=0&id=5670b521&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670b521",
  null
  
)

export default component.exports